<template>

  <div class="content" v-loading="loading">

    <el-row :gutter="8" class="filter-header">
      <el-col :span="12">
        <h3>Last submissions</h3>
      </el-col>
      <el-col :span="12" class="text-right sort-container">

        <router-link :to="{ name: 'Reservations' }">
          <el-button type="default">Reservations dashboard</el-button>
        </router-link>
      </el-col>
    </el-row>

    <unreaded-submissions-list />

    <el-dialog :title="(editedItem && editedItem._id) ? 'Form settings' : 'Create new form'" :visible.sync="showCreateForm">

      <settings-dialog :item="editedItem" />

    </el-dialog>
  </div>
</template>

<script>
import UnreadedSubmissionsList from "components/UnreadedSubmissionsList"
import SettingsDialog from "components/Forms/SettingsDialog"

const ITEM_TEMPLATE = {
  emails: [],
  options: {
    iconWidth: 70
  }
};

export default {
  components: {
    UnreadedSubmissionsList,
    SettingsDialog
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    }
  },
  data() {
    return {
      editedItem: null,
      validate: null,
      showCreateForm: false
    }
  },
  methods: {
  }
};
</script>



// WEBPACK FOOTER //
// Dashboard.vue?baf302c4